(function () {
  const links = document.querySelectorAll('.menu-page__subnav-link');
  const sections = document.querySelectorAll('.menu-page__section');
  if (!links.length || !sections.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.getAttribute('id');
        links.forEach(link => {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
        });
      }
    });
  }, { rootMargin: '-30% 0px -60% 0px' });

  sections.forEach(s => observer.observe(s));

  // Smooth scroll
  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        const offset = document.querySelector('.menu-page__subnav')?.offsetHeight || 60;
        const top = target.getBoundingClientRect().top + window.scrollY - offset - 20;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // Menu-item accordion: toggle aria-expanded on the trigger and
  // aria-hidden on the body on click. CSS reads the aria-hidden state
  // to show/hide the description + image.
  document.querySelectorAll('.menu-item__toggle').forEach(toggle => {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
  });

  // Floating scroll-to-top button: fade in past threshold, smooth-scroll on click.
  const toTop = document.querySelector('.menu-page__to-top');
  if (toTop) {
    const THRESHOLD = 500;
    const onScroll = () => {
      toTop.classList.toggle('is-visible', window.scrollY > THRESHOLD);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    toTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();
